import React from "react";

import { Props } from "./DividerInterface";

import "./Divider.scss";

const Divider: React.FC<Props> = ({ color }) => <div className={`c-divider c-divider--${color}`} />;

export default Divider;
